import styled from "styled-components";
import { baseColors } from "../../../../../themes/definitions/si/cis/base-colors";

export const ArenasHeaderDefaultBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    box-shadow: 0px 0px 6px ${baseColors.base08Shadow};
    background-color: ${baseColors.black};
`;